import React from 'react';
import { Form, Button } from '../ui-kit';
import { IconSearch } from '../ui-kit/icons';
import { redirectWithParamReplacement } from '../../utils/redirect';

const SearchFieldHamlCompat = ({ initialSearchValue }) => {
  const [searchTerm, setSearchTerm] = React.useState(initialSearchValue || '');

  return (
    <>
      <Form.InputGroup className="mb-3">
        <Form.Control
          placeholder={I18n.t('search')}
          aria-label="search"
          aria-describedby="search"
          onChange={e => {
            const value = e.target.value;
            setSearchTerm(value);
          }}
          value={searchTerm}
        />
        <Button
          variant="outline-secondary"
          onClick={() => {
            redirectWithParamReplacement('search', searchTerm);
          }}
        >
          <IconSearch />
        </Button>
      </Form.InputGroup>
    </>
  );
};

export default SearchFieldHamlCompat;
